// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1vLZd","resendInfoText":"OnGoingPaymentBox_resendInfoText__1YRxx"};